if (document.querySelectorAll('.header__main').length) {
    const { MediaQuery } = window.Foundation;
    // reveal overlay background color change (dynamically added by Foundation) has selector is not supported in FireFox
    (() => {
        const mobileSearchModal = document.querySelector(".reveal.mobileSearch");

        if (mobileSearchModal) {
            mobileSearchModal.parentElement.classList.add("mobileSearch");
        }
    })();
    // Header search box desktop
    (() => {
        let isVisible = false;
        const searchBox = $(".search-box");
        const searchInput = $(".search-box input");

        const transitionDuration = 100;
        const showHeaderSearch = function () {
            searchBox.css({ visibility: "visible" });
            searchBox.animate({ opacity: 1 }, transitionDuration);
            isVisible = true;
            searchInput.focus();
        };
        const hideHeaderSearch = function () {
            searchBox.animate({ opacity: 0 }, transitionDuration, function () {
                searchInput.val(""); // reset the input
                searchBox.css({ visibility: "hidden" }); // needed in addition to opacity to prevent cursors
                isVisible = false;
            });
        };
        const handleHeaderSearch = function (e) {
            if (!isVisible) {
                // open search box
                e.preventDefault();
                showHeaderSearch();
            } else if (searchInput.val() == "") {
                // search input empty; don't submit
                e.preventDefault();
                searchInput.focus();
            }
            // else: submit form as usual
        };
        // mobile form submit
        const handleMobileSearch = function (e) {
            const searchVal = e.target.querySelector("input").value;
            if (searchVal == "") {
                e.preventDefault();
                return;
            }
        };
        // change backgrounnd color if there's content in the search bar
        const handleSearchInputMobile = function (e) {
            const searchVal = e.target.value;
            if (searchVal !== "" && !e.target.classList.contains("active")) {
                e.target.classList.add("active");
            } else if (searchVal === "") {
                e.target.classList.remove("active");
            }
        };
        // to account for styling when users hit enter then go back and the text box is still filled
        const modalSearchBox = document.querySelector(".input__searchMobile");
        if (modalSearchBox == null) {
            return;
        }
        const initialSearchVal = modalSearchBox.value;
        if (initialSearchVal !== "" && !modalSearchBox.target.classList.contains("active")) {
            modalSearchBox.classList.add("active");
        } else if (initialSearchVal === "") {
            modalSearchBox.classList.remove("active");
        }
        window.handleSearchInputMobile = handleSearchInputMobile;
        window.handleMobileSearch = handleMobileSearch;
        window.handleHeaderSearch = handleHeaderSearch;
        window.hideHeaderSearch = hideHeaderSearch;
    })();

//set up menu - handle nav links with no urls correctly
(() => {
  MediaQuery._init();
    const topBar = document.getElementById("responsive-nav-menu");
    const mobileNavButton = document.querySelector(".button__mobileNav");
    if(!topBar)
      return;
    // watch the mobile nav style display to keep the menu open/close icon in sync
    // this more complex solution is needed due to Foundation closing the mobile nav on resize when crossing breakpoints
    const topBarObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'style') {
                const expanded = topBar.style.display !== 'none';
                mobileNavButton.classList.toggle("active", expanded);
                mobileNavButton.setAttribute("aria-expanded", expanded);

                }
            });
        });

        topBarObserver.observe(topBar, {
            attributes: true,
            attributeFilter: ['style']
        });
    })();

    // buyer portal autosuggest
    let asSearchXHR;
    let asCurrentIndex = -1;
    const asKeyCodes = { up: 38, down: 40, enter: 13, space: 32 };

    $.fn.nextOrFirst = function (selector) {
        var next = this.next(selector);
        return next.length ? next : this.siblings(selector).first();
    };

    $.fn.prevOrLast = function (selector) {
        var prev = this.prev(selector);
        return prev.length ? prev : this.siblings(selector).last();
    };

    $.fn.fetchAutosuggest = function () {
        if (asSearchXHR) {
            asSearchXHR.abort();
        }

        let searchText = $(this).val().trim();
        let $asAutosuggestResults = $(this).next();

        if (searchText.length < 3) {
            $asAutosuggestResults.hide();
            asCurrentIndex = -1;
            return;
        }

        asSearchXHR = $.ajax({
            url: "/buyer-search/autosuggest?searchText=" + encodeURIComponent(searchText),
            success: function (response) {
                if (response && response.length > 0) {
                    let suggestions = "";

                    response.forEach(function (buyer) {
                        suggestions += `<a href="${buyer.portalUrl}" class="suggestion-item" tabindex="0">${buyer.buyerName}</a>`;
                    });

                    $asAutosuggestResults.html(suggestions).show();
                    asCurrentIndex = -1;
                } else {
                    $asAutosuggestResults.hide();
                }
            },
            error: function (xhr, status, error) {
                console.log("Error getting autosuggest: " + error);
                $asAutosuggestResults.hide();
            },
        });
    }

    $(".header__main").on("keyup", ".buyer-login-search", function (e) {
        if (
            [asKeyCodes.enter, asKeyCodes.up, asKeyCodes.down, 37, 39].includes(e.keyCode)
        )
            return;

        $(this).fetchAutosuggest();
    });

    $(".header__main").on("focus", ".buyer-login-search", function () {
        if ($(this).val().length >= 2) {
            let $results = $(this).next('.buyer-login-autosuggest');
            $results.find('.selected').removeClass('.selected');
            if ($results.is(":empty")) {
                $(this).fetchAutosuggest();
            } else {
                $results.show();
            }
        }
    });

    // allow arrow keys to move selection through dropdown items
    let $dropdown = $('.autosuggest-dropdown');
    $(document).on("keydown", function (e) {
        if (!$dropdown.is(':visible'))
            return;

        const $items = $dropdown.find(".suggestion-item");
        if (!$items.length)
            return;

        let $selectedItem = $items.filter('.selected');
        let $nextItem;
        /*
        if (e.keyCode === asKeyCodes.down) {
            if ($selectedItem.length == 0)
                $nextItem = $items.first();
            else
                $nextItem = $selectedItem.nextOrFirst();

            console.log('current:' + $selectedItem.text() + ' next:' + $nextItem.text());

            $selectedItem.removeClass('selected');
            $nextItem.addClass('selected');
        }
        else if (e.keyCode === asKeyCodes.up) {
            if ($selectedItem.length == 0) {
                // do nothing
            }
            else {
                $selectedItem.removeClass('selected');

                if ($selectedItem.is(':first-child')) {
                    $(".buyer-login-search").focus();
                }
                else {
                    $nextItem = $selectedItem.prev();
                    $nextItem.addClass('selected');
                }
            }
        }
        else if (e.keyCode === asKeyCodes.enter) {
            e.preventDefault();
            $selectedItem.trigger('click');
        }*/

        if ([asKeyCodes.up, asKeyCodes.down].includes(e.keyCode)) {
            e.preventDefault();
            asCurrentIndex =
                e.keyCode === asKeyCodes.down
                    ? (asCurrentIndex + 1) % $items.length
                    : (asCurrentIndex - 1 + $items.length) % $items.length;
            $items.removeClass("selected");
            if (asCurrentIndex >= 0) {
                $items.eq(asCurrentIndex).addClass("selected");
            }
        } else if ((e.keyCode === asKeyCodes.enter) && asCurrentIndex >= 0) {
            e.preventDefault();
            const selectedItem = $items.eq(asCurrentIndex);

            if (selectedItem.length) {
                window.location.href = selectedItem.attr('href');
            }
        }
    });

    $(document).on("click", function (e) {
        let $asContainer = $('.buyer-login-autosuggest').parent();
        if (!$(e.target).closest($asContainer).length) {
            $('.buyer-login-autosuggest').hide().find('.selected').removeClass('.selected');
        }
    });
}
